import { defineAction } from '~/prix'
import { z } from 'zod'
import { incentiveDocumentStatus } from '../incentiveDocumentObject'
import incentiveDocumentConfirmAction from './incentiveDocumentConfirm.action.json' with { type: 'json' }

const incentiveDocumentConfirmDefinition = defineAction({
  ...incentiveDocumentConfirmAction,

  input: z.object({
    id: z.string().uuid(),
    status: incentiveDocumentStatus,
  }),
  output: z.object({}),
})

export default incentiveDocumentConfirmDefinition
